import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar: React.FC = () => {
  const { pathname } = useLocation();

  return (
    <>
      <div className="topbar">
        <div className="topbar-inner">
          <span className="topbar-left">Pinellas County, Florida, USA &nbsp;|&nbsp; info@uaa.education &nbsp;|&nbsp; +1 (404) 859-5563</span>
          <div className="topbar-right">
            <a href="/apply">Admissions</a>
            <a href="/contact">Contact</a>
          </div>
        </div>
      </div>
      <nav className="navbar">
        <div className="navbar-inner">
          <Link to="/" className="navbar-brand">
            <img src="/logoana.png" alt="UAA Logo" style={{ height: 48, objectFit: 'contain' }} />
          </Link>
          <div className="navbar-links">
            <Link to="/" className={`nav-link ${pathname === '/' ? 'active' : ''}`}>Home</Link>
            <Link to="/about" className={`nav-link ${pathname === '/about' ? 'active' : ''}`}>About</Link>
            <Link to="/programs" className={`nav-link ${pathname === '/programs' ? 'active' : ''}`}>Programs</Link>
            <Link to="/student-verification" className={`nav-link ${pathname === '/student-verification' || pathname === '/sorgulama' ? 'active' : ''}`}>Verification</Link>
            <Link to="/contact" className={`nav-link ${pathname === '/contact' ? 'active' : ''}`}>Contact</Link>
            <Link to="/apply" className="nav-link nav-cta">Apply Now</Link>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
